import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Output, inject } from '@angular/core';
import { App } from '@df/core/app';
import { Events } from '@df/core/service/event';
import { GoogleMapComponentDef, IMarkerOptions } from '@df/module-google-maps/google-map/google-map.component.def';
import { GoogleMapsService } from '@df/module-google-maps/google-maps.service';
import { GtmService } from '@df/module-gtm/gtm.service';
import { TimeoutService } from '@df/ng/timeout.service';
import { toGraylog } from '../to-graylog';

declare module '@df/module-google-maps/google-map/google-map.component.def' {
    interface IMarkerOptions {
        storeId?: number;
    }
}

@Component({
    selector: 'google-map',
    template: '',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoogleMapComponent extends GoogleMapComponentDef {
    @Output()
    storeSelected = new EventEmitter<number>();

    protected events = inject(Events);

    constructor(element: ElementRef, app: App, timeoutService: TimeoutService, googleMapsService: GoogleMapsService, gtm: GtmService) {
        super(element, app, timeoutService, googleMapsService);
        if (app.isPlatformBrowser && location !== undefined) {
            toGraylog('gmaps component view', { userAgent: navigator.userAgent });
            gtm.trackNonInteractionEvent('gmaps', 'googleMap', location.pathname);
        } else {
            // toGraylog('gmaps component view', 'universal');
            gtm.trackNonInteractionEvent('gmaps', 'googleMap', 'universal');
        }
    }

    protected override onMarkerClick(markerSetup: IMarkerOptions, marker: any): void {
        const storeId = markerSetup.storeId;
        if (storeId != undefined) {
            this.storeSelected.emit(storeId);
        }
    }
}
